export default function formatTimestamp(timestamp) {

    timestamp /= 1000
    // Create a Date object from the timestamp
    const date = new Date(timestamp * 1000);
  
    // Get hours, minutes, and AM/PM
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const ampm = hours >= 12 ? 'PM' : 'AM';
  
    // Convert hours to 12-hour format if necessary
    const formattedHours = hours % 12 === 0 ? 12 : hours % 12;
  
    // Pad minutes with leading zero if needed
    const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;
  
    // Return the formatted time string
    return `${formattedHours}:${formattedMinutes} ${ampm}`;
  }
  